// extracted by mini-css-extract-plugin
export default {"content":"content--fy_zC","buttons":"buttons--rVA1k","button":"button--mUy5k"};